import { useEffect } from 'react';

import { useIdentity } from '../hooks';
import { init, setIdentity } from '../utils/analytics';

init();

const Analytics = ({ children }) => {
  const identity = useIdentity();
  useEffect(() => {
    setIdentity(identity);
  }, [identity]);

  return children;
};

export default Analytics;
